import { apiClient } from './client';

const baseUrl = "/page"


export const getChildren = (
  slug: string,
  params: { page?: number; size?: number; sites?: string } = {},
  lang: string
) => {
  const { page = 1, size = 10, sites = 'cosmosy' } = params;
  return apiClient.get(`/piece?lang=${lang}`, {
    params: { slug, page, size, sites },
  });
}

export const getPageContents = (slug: string, locale:string = "en", lang: string) => {
    return apiClient.get(`/piece/${slug}?lang=${lang}`)
};

export const getCuratedOffers = (lang: string) => {
    return apiClient.get(`/cms/curated-offers?lang=${lang}`);
};

export const getCharterBundles = (lang: string) => {
    return apiClient.get(`/charter-bundles?lang=${lang}`);
};

export const getHomePageContents = (lang: string) => {
    return apiClient.get(`/page?lang=${lang}`)
};


export const getSinglePage = (slug: string, lang: string) => {
    const path = slug ? `/page/${slug}?lang=${lang}` : `/page?lang=${lang}`;
    return apiClient.get(path);
};


export const getItineraries = (
    params: { page?: number; size?: number; sites?: string; area?: string, showcase?: boolean } = {}, lang: string
) => {
    const { page = 1, size = 10, sites = 'cosmosy', area='', showcase = false } = params;
    return apiClient.get(`/cms/itineraries?lang=${lang}`, {
        params: { page, size, sites, area, showcase },
    });
}

export const getItinerary = (uuid: string, locale:string = "en", lang: string) => {
    return apiClient.get(`/cms/itineraries/${uuid}?lang=${lang}`)
};

export const getAreas = (lang: string) => {
    return apiClient.get(`/cms/areas?lang=${lang}`)
};

export const getDestination = (uuid: string, locale:string = "en", lang: string) => {
    return apiClient.get(`/cms/areas/${uuid}?lang=${lang}`)
}

export const getHeaderAnnouncement = (lang: string) => {
    return apiClient.get(`/cms/announcements?lang=${lang}`)
}

export const getPromotionImage  = (lang: string) => {
    return apiClient.get(`/promotion-section?lang=${lang}`);
};

//
// export const getPromotionYacht  = () => {
//     return apiClient.get(`/yacht-promotion-section`);
// };
